export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6833.e063b5d6.jpg";